import { Stack } from '@mui/material';
import React from 'react';
import { toast } from 'react-hot-toast';
import { useNavigate, useParams } from 'react-router-dom';
import Cookies from 'universal-cookie';
import { fetchWith401Check } from '../../helpers/http';

const RepositoryIDBridge = () => {
  const [repository, setRepository] = React.useState('');
  const navigate = useNavigate();
  const cookies = new Cookies();
  const params = useParams();
  const API_URL = process.env.REACT_APP_STAGE === 'DEVELOPMENT' ? process.env.REACT_APP_API_HOST : process.env.REACT_APP_API_HOST_PROD;

  const fetchID = async () => {
    if (!params.id) return toast.error('No ID found');
    fetchWith401Check(`${API_URL}/tabledatas/id/${params.id}`, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${cookies.get('token')}` },
      referrer: 'no-referrer',
    })
      .then(function (response) {
        if (response.ok) {
          return response.json();
        }
        return Promise.reject(response);
      })
      .then(function (response) {
        setRepository(response?.response);
      })
      .catch(function (err) {
        return toast.error(err.message || 'Something wrong happenned');
      });
  };

  React.useEffect(() => {
    fetchID();
  }, []);

  React.useEffect(() => {
    if (repository) navigate(`/portal/my-repositories/review/${repository}`);
  }, [repository]);
  return <Stack>{repository}</Stack>;
};

export default RepositoryIDBridge;
